import React from "react";
import AddLanguageLevel from "../../components/language-levels/add-language-level/AddLanguageLevel";
import PageBar from "../../components/dashboard/page-bar/PageBar";

const AddLanguageLevelPage = () => {
  return (
    <>
      <div className="pageWrapper">
        <PageBar title="Language Levels" />
        <h3 className="page-title">
          Manage Language Levels <small>Language Levels</small>
        </h3>
        <AddLanguageLevel />
      </div>
    </>
  );
};

export default AddLanguageLevelPage;
